export const PROFESSION_MUSICIAN = "MUSICIAN";
export const PROFESSION_PRODUCER = "PRODUCER";
export const PROFESSION_PAINTER = "PAINTER";
export const PROFESSION_DJ = "DJ";
export const PROFESSION_DESIGNER = "DESIGNER";
export const PROFESSION_ARTIST = "ARTIST";
export const PROFESSION_VISUAL_ARTIST = "VISUAL_ARTIST";
export const PROFESSION_ILLUSTRATOR = "ILLUSTRATOR";
export const PROFESSION_OTHER = "OTHER";
export const PROFESSION_PHOTO_VIDEO = "PHOTO_VIDEO";
export const PROFESSION_MULTIDISCIPLINARY = "MULTIDISCIPLINARY";

export const PROFESSIONS = [
  { id: PROFESSION_ARTIST, nl: "Artiest", en: "Artist" },
  { id: PROFESSION_PRODUCER, nl: "Producer", en: "Producer" },
  {
    id: PROFESSION_PHOTO_VIDEO,
    nl: "Foto-/videograaf",
    en: "Photo-/videographer",
  },
  {
    id: PROFESSION_VISUAL_ARTIST,
    nl: "Beeldend kunstenaar",
    en: "Visual artist",
  },
  { id: PROFESSION_ILLUSTRATOR, nl: "Illustrator", en: "Illustrator" },
  { id: PROFESSION_DJ, nl: "DJ", en: "DJ" },
  {
    id: PROFESSION_MULTIDISCIPLINARY,
    nl: "Multidisciplinair kunstenaar",
    en: "Multidisciplinary artist",
  },
  { id: PROFESSION_OTHER, nl: "Anders", en: "Other" },
];
